import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import { ControlLabel, FormControl, FormGroup } from 'react-bootstrap';

import './styles/import_request_form.scss';

export function SendSupportForm({
  importRequest,
  onChange,
  sourceOptions
}) {
  const [request, setRequest] = useState(importRequest);

  const handleFieldChange = field => (e) => {
    onChange(field, e.target.value);
  };

  useEffect(() => {
    setRequest(importRequest);
  }, [importRequest]);

  const renderField = (fieldName, label, controlOptions = {}) => {
    return (
      <FormGroup>
        <ControlLabel htmlFor={fieldName}>{label}</ControlLabel>
        <FormControl
          name={fieldName}
          value={request[fieldName] || ''}
          onChange={handleFieldChange(fieldName)}
          {...controlOptions}
        />
      </FormGroup>
    );
  };

  const renderSourceField = () => {
    const options = map(sourceOptions, ({ label, value }) => (
      <option key={value} value={value}>{label}</option>
    ));

    return (
      <FormGroup>
        <ControlLabel htmlFor="source">Import Source</ControlLabel>
        <FormControl
          componentClass="select"
          required
          value={request.source || ''}
          onChange={handleFieldChange('source')}
        >
          <option disabled key="_empty" value="">
            Select an import source...
          </option>
          {options}
          <option key="other" value="other">Other</option>
        </FormControl>
      </FormGroup>
    );
  };

  return (
    <form className="import-request-form">
      {renderSourceField()}
      {request.source === 'other' && renderField('customSourceName', 'Data Source', { required: true })}
      {renderField('clientNotes', 'Memo', {
        componentClass: 'textarea',
        placeholder: 'Include any notes you may have for the Data Team...'
      })}
    </form>
  );
}

SendSupportForm.propTypes = {
  importRequest: PropTypes.shape({
    clientNotes: PropTypes.string,
    customSourceName: PropTypes.string,
    files: PropTypes.array.isRequired,
    name: PropTypes.string,
    source: PropTypes.string
  }).isRequired,
  sourceOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })).isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};
